(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/form.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/form.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const TICKETS = [{
  count: 5,
  price: 30,
  title: 'Lilla Trisspaketet',
  code: 'SVSIN150',
  img: 'triss30x5.png',
  alt: '5 triss i en fjäderform',
  default: true,
  label: 'Small'
}, {
  count: 7,
  price: 30,
  title: 'Mellanstora Trisspaketet',
  img: 'triss30x7.png',
  alt: '7 triss i en fjäderform',
  code: 'SVSIN210',
  label: 'Medium'
}, {
  count: 10,
  price: 30,
  title: 'Stora Trisspaketet',
  img: 'triss30x10.png',
  alt: '10 triss i en fjäderform',
  code: 'SVSIN300',
  label: 'Large'
}];
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  useActiveSuspension
} = svs.ticketSubscription;
const {
  Widget
} = svs.trissSubscription;
const Button = svs.ui.ReactButton;
const Form = svs.ui.reactForm.Form;
const SPEL_PAUS_ERROR_CODE = 1019;
setGlobal('svs.ticketSubscription.Form', _ref => {
  let {
    onComplete
  } = _ref;
  const {
    hasActiveSuspension
  } = useActiveSuspension();
  const handleOnClick = async ticketCode => {
    const extraParams = {
      branding: 'triss',
      product: 'triss',
      subscription: true
    };
    if (svs.core.userSession.isBlocked()) {
      svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage();
    } else if (hasActiveSuspension) {
      svs.tur.apierrors.showErrorMessage({
        response: SPEL_PAUS_ERROR_CODE
      });
    } else if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      var _svs, _svs$setupExtraData;
      svs.trissSubscription.utils.showSubDialog(_objectSpread(_objectSpread({}, TICKETS.find(t => t.code === ticketCode)), {}, {
        onComplete: () => onComplete && onComplete()
      }));
      await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
        extraData: extraParams
      }));
    } else {
      svs.components.customer_login.login({
        returnNewCustomer: true,
        extraParams
      });
    }
  };
  return React.createElement(Form, null, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement("div", null, TICKETS.map(ticket => React.createElement("section", {
    id: ticket.title.split(' ')[0].toLowerCase(),
    key: ticket.code
  }, React.createElement(GridRow, {
    className: "margin-bottom-2"
  }, React.createElement(GridCol, {
    className: "u-flex u-flex-align-items-center",
    xs: 3
  }, React.createElement("img", {
    alt: ticket.alt,
    className: "ticket-stacked-image",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/triss-subscription/").concat(ticket.img)
  })), React.createElement(GridCol, {
    md: 6,
    xs: 6
  }, React.createElement("h4", null, ticket.title), React.createElement("div", null, "".concat(ticket.count, " Triss i m\xE5naden")), React.createElement("div", null, "".concat(ticket.price * ticket.count, " kr"))), React.createElement(GridCol, {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center f-bold",
    xs: 3
  }, React.createElement(Button, {
    "aria-label": "V\xE4lj ".concat(ticket.title, " ").concat(ticket.count, " lotter"),
    block: true,
    className: "qa-pick-".concat(ticket.count),
    focus: true,
    onClick: e => {
      e.preventDefault();
      svs.components.analytics.trackEvent({
        category: 'Triss subscription',
        action: 'Select',
        opt_label: ticket.label
      });
      handleOnClick(ticket.code);
    }
  }, "V\xE4lj")))))), React.createElement(Widget, {
    name: "bottomWidget"
  }))));
});

 })(window);